import React, { useCallback } from "react";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Modal, List, Typography } from "antd";

import colors from "../../../../colors";
import {
  post,
  checkHttpStatus,
  checkResponseGet,
} from "../../../../modules/httpFunctions";
import CustomIcon from "../../../app/generic/customIcon";
import { warningModal } from "../../../../modules/messages";
import { handleError } from "../../../../modules/errorLogger";
import CalculationTitle from "../../../calculator/resultDisplay/calculationTitle";

const { Item } = List;

const sendConsignments = (
  selectedConsignments,
  loadConsignments,
  filterParams,
  setLoading,
  setConsignments,
  setModalVisible,
  setSendResult,
  setConsignmentsIdsForPrint,
  intl
) => {
  setLoading(true);
  setConsignments();
  post(
    "consignment/send",
    {
      consignmentIds: selectedConsignments,
    },
    true,
    300000
  )
    .then((r) => {
      if (checkHttpStatus(r) && checkResponseGet(r)) {
        setModalVisible(true);
        setSendResult(r.data.data);
        setConsignmentsIdsForPrint(selectedConsignments);
      } else {
        warningModal(
          (r && r.data && r.data.message) ||
            intl.formatMessage({
              id: "consignment.send.error",
              defaultMessage: "Při odesílání zásilek nastala chyba!",
            })
        );
      }
      setLoading(false);
      loadConsignments(filterParams);
    })
    .catch((err) => {
      warningModal(
        intl.formatMessage({
          id: "consignment.send.error",
          defaultMessage: "Při odesílání zásilek nastala chyba!",
        })
      );
      handleError(err);
    });
};

const sendConsignmentsDebounced = AwesomeDebouncePromise(sendConsignments, 500);

const SendModal = ({
  showModal,
  setLoading,
  onHideModal,
  filterParams,
  setSendResult,
  setConsignments,
  setModalVisible,
  loadConsignments,
  selectedConsignments,
  selectedConsignmentIds,
  setConsignmentsIdsForPrint,
}) => {
  const intl = useIntl();

  const handleModalHide = useCallback(() => {
    onHideModal(false);
  }, [onHideModal]);

  const handleSending = useCallback(() => {
    handleModalHide();
    sendConsignmentsDebounced(
      selectedConsignmentIds,
      loadConsignments,
      filterParams,
      setLoading,
      setConsignments,
      setModalVisible,
      setSendResult,
      setConsignmentsIdsForPrint,
      intl
    );
  }, [
    intl,
    setLoading,
    filterParams,
    setSendResult,
    handleModalHide,
    setConsignments,
    setModalVisible,
    loadConsignments,
    selectedConsignmentIds,
    setConsignmentsIdsForPrint,
  ]);

  return (
    <Modal
      title={
        <Row align="middle">
          <Col>
            <CustomIcon
              marginRight={10}
              color={colors.YELLOW}
              type="question-circle"
            />
            <FormattedMessage
              id="messages.confirm"
              defaultMessage="Potvrzení"
            />
          </Col>
        </Row>
      }
      visible={showModal}
      onOk={handleSending}
      onCancel={handleModalHide}
      okText={<FormattedMessage id="messages.yes" defaultMessage="Ano" />}
      cancelText={<FormattedMessage id="messages.no" defaultMessage="Ne" />}
    >
      <Row gutter={[0, 40]}>
        <Col>
          <FormattedMessage
            id="consignment.send.question"
            defaultMessage="Opravdu si přejete všechny označené zásilky odeslat do DHL? Pokud dojde k odeslání zásilek, nebude u nich již možné nic změnit."
          />
        </Col>
      </Row>
      {selectedConsignments &&
        selectedConsignments.some((c) => c.transportPrice) && (
          <Row gutter={[0, 40]}>
            <Col>
              <List
                header={
                  <Typography.Text strong>
                    <FormattedMessage
                      id="consignment.send.price"
                      defaultMessage="Aktuální ceny přepravy odesílaných zásilek"
                    />
                  </Typography.Text>
                }
                pagination={{ pageSize: 5 }}
                dataSource={selectedConsignments}
                itemLayout="horizontal"
                renderItem={(c) => (
                  <Item>
                    <FormattedMessage
                      id={
                        c.customerReference
                          ? "consignment.send.withRef"
                          : "consignment.send.withoutRef"
                      }
                      defaultMessage={
                        c.customerReference
                          ? "Zásilka ref. {reference}"
                          : "Zásilka bez reference"
                      }
                      values={{ reference: c.customerReference }}
                    />
                    <CalculationTitle
                      price={c.transportPrice}
                      items={c.transportPriceItems}
                      priceCurrency={c.transportPriceCurrency}
                    />
                  </Item>
                )}
              />
            </Col>
          </Row>
        )}
    </Modal>
  );
};

export default SendModal;
